<template>
    <svg
        version="1.1"
        id="Lager_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        :viewBox="text ? '0 0 1570 370' : '0 0 370 370'"
        style="enable-background: new 0 0 1570 370"
        xml:space="preserve"
    >
        <g>
            <circle class="st0" cx="181.8" cy="185" r="176" />
        </g>
        <g v-if="text">
            <path
                class="st1"
                d="M485.4,212.4h-21.8v51H432V121.6h53.4c14.4,0,26.1,4.3,35.1,12.8S534,153.8,534,167c0,13.5-4.5,24.4-13.5,32.8
		C511.5,208.2,499.8,212.4,485.4,212.4z M463.8,185.2h18.4c6,0,10.9-1.6,14.6-4.9c3.7-3.3,5.6-7.6,5.6-13.1c0-5.6-1.8-10-5.5-13.3
		s-8.6-4.9-14.7-4.9h-18.4L463.8,185.2L463.8,185.2z"
            />
            <path
                class="st1"
                d="M592.8,161c15.1,0,27.6,4.9,37.7,14.8c10.1,9.9,15.1,22.5,15.1,37.8s-5,28-15.1,37.9s-22.6,14.9-37.7,14.9
		c-14.9,0-27.5-5-37.6-15S540,228.8,540,213.6s5.1-27.8,15.2-37.7C565.4,166,577.9,161,592.8,161z M592.8,238.4
		c6.3,0,11.6-2.1,15.9-6.4c4.3-4.3,6.5-10.4,6.5-18.4s-2.2-14.1-6.5-18.3c-4.3-4.2-9.6-6.3-15.9-6.3c-6.1,0-11.4,2.1-15.8,6.4
		c-4.4,4.3-6.6,10.3-6.6,18.2s2.2,14,6.6,18.3C581.4,236.3,586.7,238.4,592.8,238.4z"
            />
            <path
                class="st1"
                d="M657,235.2l25.8-4.6c0.3,3.7,1.7,6.9,4.3,9.5s6.4,3.9,11.3,3.9c3.7,0,6.6-0.8,8.6-2.5s3-3.7,3-6.1
		c0-4-3.3-6.7-9.8-8.2l-11.4-2.6c-10.1-2.1-17.6-5.9-22.4-11.3c-4.8-5.4-7.2-11.8-7.2-19.3c0-9.2,3.6-17,10.9-23.4
		c7.3-6.4,16.4-9.6,27.3-9.6c12.9,0,22.6,3.1,29.1,9.3s10,13,10.7,20.3l-25.2,4.6c-0.4-3.6-1.8-6.5-4.1-8.8s-5.7-3.4-10.1-3.4
		c-2.9,0-5.5,0.8-7.6,2.4s-3.2,3.7-3.2,6.2c0,4,2.6,6.5,7.8,7.4l13.2,2.6c10,2,17.6,5.8,22.8,11.4s7.8,12.2,7.8,19.8
		c0,9.2-3.5,17.1-10.4,23.7s-16.7,9.9-29.2,9.9c-7.3,0-13.8-1.1-19.5-3.2s-10-4.9-13-8.3s-5.3-6.8-6.8-10.1
		C658.2,241.5,657.3,238.3,657,235.2z"
            />
            <path
                class="st1"
                d="M794.8,135v29h19.4v26.6h-19.4v37.2c0,6.9,3.7,10.4,11,10.4c2.4,0,5.1-0.3,8-1v25.2c-3.7,1.9-9,2.8-15.8,2.8
		c-10.3,0-18.4-2.9-24.3-8.6c-5.9-5.7-8.9-13.5-8.9-23.4v-42.6h-17.6V164h5c5.1,0,8.9-1.5,11.5-4.5s3.9-6.9,3.9-11.7V135H794.8z"
            />
            <path
                class="st1"
                d="M897.8,164v30c-2.8-0.7-6-1-9.6-1c-6.8,0-12.4,2.2-16.7,6.6c-4.3,4.4-6.5,11.2-6.5,20.4v43.4h-30.4V164H864
		v13.4c2.4-5.1,6.1-8.7,11-11s9.9-3.4,14.8-3.4C892.9,163,895.6,163.4,897.8,164z"
            />
            <path
                class="st1"
                d="M960.6,161c15.1,0,27.6,4.9,37.7,14.8s15.1,22.5,15.1,37.8s-5,28-15.1,37.9s-22.6,14.9-37.7,14.9
		c-14.9,0-27.5-5-37.6-15s-15.2-22.6-15.2-37.8s5.1-27.8,15.2-37.7C933.2,166,945.7,161,960.6,161z M927.6,147.8
		c-2.9-2.9-4.4-6.5-4.4-10.8s1.5-7.9,4.4-10.9s6.5-4.5,10.8-4.5s7.9,1.5,10.9,4.5s4.5,6.6,4.5,10.9s-1.5,7.9-4.5,10.8
		s-6.6,4.4-10.9,4.4C934.2,152.2,930.6,150.8,927.6,147.8z M960.6,238.4c6.3,0,11.6-2.1,15.9-6.4s6.5-10.4,6.5-18.4
		s-2.2-14.1-6.5-18.3s-9.6-6.3-15.9-6.3c-6.1,0-11.4,2.1-15.8,6.4s-6.6,10.3-6.6,18.2s2.2,14,6.6,18.3
		C949.2,236.3,954.5,238.4,960.6,238.4z M971.8,147.8c-2.9-2.9-4.4-6.5-4.4-10.8s1.5-7.9,4.4-10.9s6.5-4.5,10.8-4.5
		s7.9,1.5,10.9,4.5s4.5,6.6,4.5,10.9s-1.5,7.9-4.5,10.8s-6.6,4.4-10.9,4.4C978.4,152.2,974.8,150.8,971.8,147.8z"
            />
            <path
                class="st1"
                d="M1024.8,235.2l25.8-4.6c0.3,3.7,1.7,6.9,4.3,9.5c2.6,2.6,6.4,3.9,11.3,3.9c3.7,0,6.6-0.8,8.6-2.5s3-3.7,3-6.1
		c0-4-3.3-6.7-9.8-8.2l-11.4-2.6c-10.1-2.1-17.6-5.9-22.4-11.3s-7.2-11.8-7.2-19.3c0-9.2,3.6-17,10.9-23.4s16.4-9.6,27.3-9.6
		c12.9,0,22.6,3.1,29.1,9.3s10,13,10.7,20.3l-25.2,4.6c-0.4-3.6-1.8-6.5-4.1-8.8c-2.3-2.3-5.7-3.4-10.1-3.4c-2.9,0-5.5,0.8-7.6,2.4
		s-3.2,3.7-3.2,6.2c0,4,2.6,6.5,7.8,7.4l13.2,2.6c10,2,17.6,5.8,22.8,11.4c5.2,5.6,7.8,12.2,7.8,19.8c0,9.2-3.5,17.1-10.4,23.7
		s-16.7,9.9-29.2,9.9c-7.3,0-13.8-1.1-19.5-3.2s-10-4.9-13-8.3s-5.3-6.8-6.8-10.1C1026,241.5,1025.1,238.3,1024.8,235.2z"
            />
            <path
                class="st1"
                d="M1162.6,135v29h19.4v26.6h-19.4v37.2c0,6.9,3.7,10.4,11,10.4c2.4,0,5.1-0.3,8-1v25.2c-3.7,1.9-9,2.8-15.8,2.8
		c-10.3,0-18.4-2.9-24.3-8.6s-8.9-13.5-8.9-23.4v-42.6H1115V164h5c5.1,0,8.9-1.5,11.5-4.5s3.9-6.9,3.9-11.7V135H1162.6z"
            />
            <path
                class="st1"
                d="M1198.4,236c0-8.4,2.7-15.2,8.2-20.3s12.5-8.4,21.2-9.7l23.4-3.6c4.8-0.7,7.2-2.9,7.2-6.8
		c0-3.1-1.3-5.6-3.9-7.7s-6.2-3.1-10.7-3.1c-5.1,0-9.1,1.4-12.1,4.3s-4.6,6.3-4.9,10.3l-26.4-5.4c0.7-8.3,4.8-15.8,12.3-22.7
		c7.5-6.9,18-10.3,31.3-10.3c15.1,0,26.2,3.6,33.3,10.8c7.1,7.2,10.7,16.4,10.7,27.6V248c0,6.3,0.4,11.4,1.2,15.4h-27.4
		c-0.7-2.7-1-6.4-1-11.2c-5.7,9.3-15.1,14-28,14c-10.5,0-18.9-3-25.1-8.9C1201.5,251.4,1198.4,244.3,1198.4,236z M1240.2,244.2
		c5.2,0,9.5-1.5,13-4.6s5.2-8.1,5.2-15.2V220l-18.8,3c-7.5,1.2-11.2,4.9-11.2,11c0,2.8,1,5.2,2.9,7.2
		C1233.3,243.2,1236.2,244.2,1240.2,244.2z"
            />
            <path
                class="st0"
                d="M1318.4,259.1c-4-4.1-6-8.9-6-14.5s2-10.4,6-14.4s8.8-6,14.4-6s10.4,2,14.5,6s6.1,8.8,6.1,14.4
		c0,5.5-2,10.3-6.1,14.4s-8.9,6.2-14.5,6.2S1322.4,263.2,1318.4,259.1z"
            />
            <path
                class="st1"
                d="M1370.8,235.2l25.8-4.6c0.3,3.7,1.7,6.9,4.3,9.5c2.6,2.6,6.4,3.9,11.3,3.9c3.7,0,6.6-0.8,8.6-2.5s3-3.7,3-6.1
		c0-4-3.3-6.7-9.8-8.2l-11.4-2.6c-10.1-2.1-17.6-5.9-22.4-11.3s-7.2-11.8-7.2-19.3c0-9.2,3.6-17,10.9-23.4s16.4-9.6,27.3-9.6
		c12.9,0,22.6,3.1,29.1,9.3s10,13,10.7,20.3l-25.2,4.6c-0.4-3.6-1.8-6.5-4.1-8.8c-2.3-2.3-5.7-3.4-10.1-3.4c-2.9,0-5.5,0.8-7.6,2.4
		s-3.2,3.7-3.2,6.2c0,4,2.6,6.5,7.8,7.4l13.2,2.6c10,2,17.6,5.8,22.8,11.4c5.2,5.6,7.8,12.2,7.8,19.8c0,9.2-3.5,17.1-10.4,23.7
		s-16.7,9.9-29.2,9.9c-7.3,0-13.8-1.1-19.5-3.2s-10-4.9-13-8.3s-5.3-6.8-6.8-10.1C1372,241.5,1371.1,238.3,1370.8,235.2z"
            />
            <path
                class="st1"
                d="M1537,227.6l25.4,7.2c-2.5,9.2-7.8,16.8-15.8,22.7s-18,8.9-30,8.9c-14.4,0-26.6-4.8-36.7-14.4
		s-15.1-22.5-15.1-38.6c0-15.5,4.9-28.1,14.7-37.8c9.8-9.7,21.4-14.6,34.9-14.6c15.5,0,27.6,4.5,36.5,13.5s13.3,21.5,13.3,37.5
		c0,5.1-0.2,8.2-0.6,9.4h-69.2c0.3,5.5,2.6,10,7,13.7s9.6,5.5,15.6,5.5C1527.3,240.6,1534,236.3,1537,227.6z M1495,201.8h39.8
		c-0.3-4.5-2-8.5-5.3-11.8s-8.2-5-14.7-5c-5.9,0-10.5,1.7-14,5.2C1497.4,193.7,1495.4,197.6,1495,201.8z"
            />
        </g>
        <g transform="translate(0,-270.54165)">
            <path
                class="st2"
                d="M282.7,390.9l-94.3,94.3l-6,6l-6.4-5.4l-61.2-52l11.9-14.1l54.8,46.6l89.5-89.5c-1.6-0.6-3.4-0.8-5.2-0.8H97.9
		c-9.4,0-17.2,7.8-17.2,17.2v124.7c0,9.5,7.8,17.2,17.2,17.2h167.8c9.4,0,17.2-7.7,17.2-17.2V393.2
		C282.9,392.5,282.8,391.6,282.7,390.9z"
            />
        </g>
    </svg>
</template>
<script>
export default {
    props: {
        text: {
            type: Boolean,
            default: true,
        }
    },
};
</script>
<style type="text/css">
.st0 {
    fill: #fff;
}
.st1 {
    fill: #fff;
}
.st2 {
    fill: #0434ec;
}
</style>
